export const queryKeys = {
  entities: {
    all: ['entities'] as const,
    lists: () => ['entities', 'list'] as const,
    list: (
      type: string,
      params?: {
        limit?: number | 'all';
        offset?: number;
        order?: string;
        filters?: Record<string, string>;
      },
    ) => ['entities', 'list', type, params] as const,
    details: () => ['entities', 'detail'] as const,
    detail: (type: string, id: string) => ['entities', 'detail', type, id] as const,
    relationships: (id: string, direction?: 'in' | 'out' | 'both') =>
      ['entities', 'relationships', id, direction] as const,
  },
  locations: {
    hierarchy: (filters?: Record<string, string> | null) =>
      ['locations', 'hierarchy', filters] as const,
  },
  hierarchy: {
    entities: (endpoint: string, filters?: Record<string, string> | null) =>
      ['hierarchy', endpoint, filters] as const,
  },
  entityTypes: {
    all: ['entityTypes'] as const,
    config: (type: string) => ['entityTypes', 'config', type] as const,
    schema: (type: string) => ['entityTypes', 'schema', type] as const,
    uiSchema: (type: string) => ['entityTypes', 'uiSchema', type] as const, // ✅ NEW
    configWithSchema: (type: string) => ['entityTypes', 'configWithSchema', type] as const,
    withSchemas: (type: string) => ['entityTypes', 'withSchemas', type] as const, // ✅ NEW
  },
  system: {
    all: ['system'] as const,
    uiNav: ['system', 'uiNavigation'] as const,
  },
  search: {
    all: ['search'] as const,
    entities: (type: string, query: string, filters?: Record<string, unknown>) =>
      ['search', 'entities', type, query, filters] as const,
  },
  bulkInventoryBin: {
    all: ['bulkInventoryBin'] as const,
    list: () => ['bulkInventoryBin', 'pendingReview'] as const,
    pendingReview: () => ['bulkInventoryBin', 'pendingReview'] as const,
    pendingDisposal: () => ['bulkInventoryBin', 'pendingDisposal'] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: () => ['orders', 'list'] as const,
    lineItems: (orderId: string) => ['orders', 'line-items', orderId] as const,
    lineItemsHistory: (orderId: string) => ['orders', 'line-items-history', orderId] as const,
  },
  catalog: {
    all: ['catalog'] as const,
    nonBuy: () => ['catalog', 'nonBuy'] as const,
    maintenanceEligible: () => ['catalog', 'maintenanceEligible'] as const,
    imageMetadata: (catalogId: string) => ['catalog', 'image-metadata', catalogId] as const,
  },
  transactions: {
    all: ['transactions'] as const,
    list: (params?: { limit?: number }) => ['transactions', 'list', params] as const,
  },
  transfersShipping: {
    all: ['transfersShipping'] as const,
    logs: () => ['transfersShipping', 'logs'] as const,
    logItems: (logId: string) => ['transfersShipping', 'log-items', logId] as const,
  },
  maintenanceRequests: {
    all: ['maintenanceRequests'] as const,
    logs: () => ['maintenanceRequests', 'logs'] as const,
    logItems: (maintenanceSendTransactionId: string) =>
      ['maintenanceRequests', 'log-items', maintenanceSendTransactionId] as const,
    receivableItems: (maintenanceSendTransactionId: string) =>
      ['maintenanceRequests', 'receivable-items', maintenanceSendTransactionId] as const,
  },
  notifications: {
    emailSchedules: {
      list: () => ['notifications', 'email-schedules', 'list'] as const,
      runs: (scheduleId: string) =>
        ['notifications', 'email-schedules', 'runs', scheduleId] as const,
    },
    emailAdmin: {
      smtpConfig: () => ['notifications', 'email-admin', 'smtp-config'] as const,
      outbox: (limit: number) => ['notifications', 'email-admin', 'outbox', limit] as const,
      templates: () => ['notifications', 'email-admin', 'templates'] as const,
    },
  },
  lossRecord: {
    all: ['lossRecord'] as const,
    list: () => ['lossRecord', 'list'] as const,
    detail: (id: string) => ['lossRecord', 'detail', id] as const,
  },
  adminConfig: {
    all: ['adminConfig'] as const,
    list: (prefix?: string) => ['adminConfig', 'list', prefix] as const,
  },
  cifStamp: {
    detail: ['cifStamp'] as const,
  },
  systemHealth: {
    status: ['systemHealth', 'status'] as const,
    detail: ['systemHealth', 'detail'] as const,
  },
  systemLogs: {
    all: ['systemLogs'] as const,
    list: (params?: Record<string, unknown>) => ['systemLogs', 'list', params] as const,
    summary: (params?: Record<string, unknown>) => ['systemLogs', 'summary', params] as const,
  },
} as const;
